<script setup lang="ts"></script>

<template>
  <NuxtLayout>
    <NuxtPage :keepalive="true" />
  </NuxtLayout>
</template>

<style></style>
